"use client";

import React, { useState, useEffect } from 'react';
import HeaderSection from '../../layout/HeaderSection';
import PartnersGrid from './components/PartnersGrid';
import Footer from "../../layout/Footer";
import { partners } from "../../../api/collections/partnersApi";
import { Partner } from "../../../types/partnerType";

/**
 * Partner Page Component
 * Main component for the partners page displaying partnership information
 */
const PartnerPage: React.FC = () => {
  const [partnersData, setPartnersData] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await partners.getAll();

        if (response.success && response.data) {
          setPartnersData(response.data);
        } else {
          setError(response.error?.message || "Không thể tải dữ liệu đối tác");
        }
      } catch (err) {
        setError("Đã xảy ra lỗi khi tải dữ liệu đối tác");
        console.error("Error fetching partners:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  return (
    <div className="min-h-screen">
      <HeaderSection 
        title="Đối tác"
        subtitle="Kiến tạo xanh toà sáng tâm hồn Việt"
        backgroundImage="/header_90ad.png"
        ariaLabel="Partners page header"
      />

      {/* Partners Grid Section */}
      <PartnersGrid partners={partnersData} loading={loading} error={error} />

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default PartnerPage;
